module.exports = __webpack_public_path__ + "img/logo.39f45848.png";